import { AppThunkAction } from "..";
import { KnownAction, GET_MOBILE_DEVICE_COUNT, GET_MOBILE_DEVICE_COUNT_LOADER, GET_DEVICES_LOADER, GET_AUTHENTICATED_DEVICES } from "./types";
import * as httpClient from "../../util/httpClient";

export const actionCreators = {
    getMobileDeviceCount: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: GET_MOBILE_DEVICE_COUNT_LOADER, isLoading: true });
        getMobileDeviceCountAPICall(dispatch, getState);
    },
    getAuthenticatedDevices: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: GET_DEVICES_LOADER, isLoadingDevices: true });
        getAuthenticatedDevicesAPICall(dispatch, getState);
    },
    revokeRegisteredDevice:
        (appGuid: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const rqstBody = {
                AppGuid: appGuid,
            };
            dispatch({ type: GET_DEVICES_LOADER, isLoadingDevices: true });
            httpClient
                .sendRequest("POST", "api/accountInfo/revokeRegisteredDevice", rqstBody)
                .then((data) => {
                    getAuthenticatedDevicesAPICall(dispatch, getState);
                    getMobileDeviceCountAPICall(dispatch, getState);
                })
                .catch(function (error) {
                    dispatch({ type: GET_DEVICES_LOADER, isLoadingDevices: false });
                });
        },
};

function getAuthenticatedDevicesAPICall(dispatch: any, getState: any) {
    httpClient
        .sendRequest("GET", "api/accountInfo/getMobileRegistrationDetails")
        .then((data) => {
            dispatch({ type: GET_DEVICES_LOADER, isLoadingDevices: false });
            if (data && data.hasError === false) {
                dispatch({ type: GET_AUTHENTICATED_DEVICES, authenticatedDevices: data.registration });
            }
        })
        .catch(function (error) {
            dispatch({ type: GET_DEVICES_LOADER, isLoadingDevices: false });
        });
}

function getMobileDeviceCountAPICall(dispatch: any, getState: any) {
    httpClient
        .sendRequest("POST", "api/MobileDeviceCount/GetMobileDeviceCount")
        .then((data) => {
            dispatch({ type: GET_MOBILE_DEVICE_COUNT_LOADER, isLoading: false });
            const counts = data["numberOfAuthenticatedDevices"];

            if (counts !== null) {
                dispatch({ type: GET_MOBILE_DEVICE_COUNT, numberOfAuthenticatedDevices: counts });
            }
        })
        .catch(function (error) {
            dispatch({ type: GET_MOBILE_DEVICE_COUNT_LOADER, isLoading: false });
        });
}
